// extracted by mini-css-extract-plugin
export default {"latest_photo_swiper":"LatestActivities_latest_photo_swiper__Xycz+","latest_photo_swiper_container":"LatestActivities_latest_photo_swiper_container__JdvsH"};